let url = "https://apimedidores.apidev.info" 
// let url = "http://localhost:4088"

module.exports = {
  url
}

/** marcuxo marcuxoDevOPS */